import { usePageCategory } from "./usePageCategory";

/** Contains level 2 menu entry/name like. 'organization‘ ‘strategy‘ */
export function usePageSubcategory(pathname = location.pathname) {
  const category = usePageCategory(pathname);
  const uriParts = pathname.split('/').filter(Boolean).slice(1);
  if (uriParts.length === 0) {
    return category;
  }
  return uriParts[0];
}